import { render, staticRenderFns } from "./Communicate.vue?vue&type=template&id=6193aea1&"
import script from "./Communicate.vue?vue&type=script&lang=js&"
export * from "./Communicate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports